<template>
  <div class="box flex-stretch">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="exporting">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Exporting, please wait
        </div>
      </div>
    </div>
    <div class="box-content flex-stretch relative">
      <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8; z-index: 6; min-width: 400px; border-radius: 15px;" v-show="filtering"></div>
      <div class="flex justify-end mb-3">
        <div class="pr-3-2xs pb-1 pb-0-2xs">
          <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open, reports_menu_open = false, data_mode_menu_open = false">
            <div class="multi-select-input-placeholder">
              Filter...
              <div class="dropdown-icon">
                <i class="fal fa-chevron-down"></i>
              </div>
            </div>
            <div class="multi-select-input-inner" v-show="filter_dropdown_open" @click.stop>
              <div class="multi-select-input-group">
                <h1 class="input-group-title">Date</h1>
                <div class="checkboxes">
                  <div class="">
                    <div class="input-group">
                      <div class="input-group-addon" style="width: 60px;">From:</div>
                      <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
                    </div>
                    <div class="input-group mt-1">
                      <div class="input-group-addon" style="width: 60px;">To:</div>
                      <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Upload System Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="system_type in all_epwin_system_types">
                    <label>
                      <input type="checkbox" name="system_types" :value="system_type.id" v-model="selected_system_types">
                      <span class="checkbox-label">{{ system_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Upload Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="content_upload_type in all_content_upload_types">
                    <label>
                      <input type="checkbox" name="status" :value="content_upload_type.id" v-model="content_upload_type_filter">
                      <span class="checkbox-label">{{ content_upload_type.name }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Company Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="company_type in all_company_types">
                    <label>
                      <input type="checkbox" name="company_types" :value="company_type.id" v-model="selected_company_types">
                      <span class="checkbox-label">{{ company_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Company System Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="system_type in all_epwin_system_types">
                    <label>
                      <input type="checkbox" name="company_system_types" :value="system_type.id" v-model="selected_company_system_types">
                      <span class="checkbox-label">{{ system_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ml-3">
          <div class="btn-dropdown" :class="{ '_open' : data_mode_menu_open }" @click.stop="data_mode_menu_open = !data_mode_menu_open, filter_dropdown_open = false, reports_menu_open = false">
            <div class="btn-primary">
              Show As:
              <i class="fal fa-chevron-up" v-if="data_mode_menu_open"></i>
              <i class="fal fa-chevron-down" v-if="!data_mode_menu_open"></i>
            </div>
            <div class="btn-dropdown-menu" @click.stop>
              <a @click.stop="data_mode = 'table', data_mode_menu_open = false" class="cursor-pointer">
                <i class="fal fa-check" v-if="data_mode === 'table'"></i>
                Table
              </a>
              <a @click.stop="data_mode = 'pie', data_mode_menu_open = false" class="cursor-pointer">
                <i class="fal fa-check" v-if="data_mode === 'pie'"></i>
                Pie Chart
              </a>
            </div>
          </div>
        </div>
        <div class="ml-3">
          <a class="btn-primary" @click.stop.prevent="exportSpreadsheet()">
            Export
          </a>
        </div>
        <div class="ml-3">
          <reports-menu :menu_open="reports_menu_open" @open="reports_menu_open = true, filter_dropdown_open = false, data_mode_menu_open = false" @close="reports_menu_open = false"></reports-menu>
        </div>
      </div>
      <div id="reports-downloads-piechart" class="flex-stretch" v-show="data_mode === 'pie'"></div>
      <div id="reports-downloads-table" class="google-table-wrapper flex-stretch" v-show="data_mode === 'table'"></div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  async mounted() {
    let lastYear = new Date();
    lastYear.setFullYear(lastYear.getFullYear() - 1);
    this.date_filter_start = lastYear;
    window.googleCharts.charts.load('current', {
      'packages': ['table', 'corechart']
    });
    this.loadContentUploadTypesList();
    this.loading = false;
  },
  props: [
    'all_content_upload_types',
    'all_company_types',
    'all_epwin_system_types'
  ],
  components: {
    'datepicker': Datepicker,
  },
  data() {
    return {
      filtering: false,
      date_filter_start: null,
      date_filter_end: new Date(),
      downloads_list: [],
      loading: true,
      content_upload_type_filter: [],
      content_upload_types: [],
      filter_dropdown_open: false,
      selected_company_types: [],
      selected_system_types: [],
      selected_company_system_types: [],
      reports_menu_open: false,
      downloads_pie_data: [],
      data_mode: 'table',
      data_mode_menu_open: false,
      exporting: false,
    }
  },
  methods: {
    drawPie() {
      let header_data = [['Download Type', 'Downloads']];
      let pie_data = header_data.concat(this.downloads_pie_data);

      let data = window.googleCharts.visualization.arrayToDataTable(pie_data);

      let options = {
        title: 'Downloads'
      };

      let chart = new window.googleCharts.visualization.PieChart(document.getElementById('reports-downloads-piechart'));

      chart.draw(data, options);
    },
    drawTable() {
      let data = new window.googleCharts.visualization.DataTable();
      let data_rows = [];
      let total_downloads = 0;

      let download_type_total_count = [];

      this.content_upload_types.forEach(function(){
        download_type_total_count.push(0);
      });

      Object.values(this.downloads_list).forEach(function(download_date) {
        let rows = [download_date.date, download_date.total_downloads];
        let download_type_data_rows = [];
        total_downloads = total_downloads + download_date.total_downloads;
        download_date.content_upload_types.forEach(function(content_upload_type, index) {
          download_type_data_rows.push(content_upload_type.download_count);
        });
        download_type_total_count = download_type_total_count.map((count, index) => count + download_type_data_rows[index]);
        let all_rows = rows.concat(download_type_data_rows);
        data_rows.push(all_rows);
      });

      data.addColumn({type: 'string', label: 'Date', p: {className: 'date-column'}});
      data.addColumn('number', `Total Downloads (${total_downloads})`);

      this.content_upload_types.forEach(function(content_upload_type, index){
        data.addColumn('number', `${content_upload_type.name} (${download_type_total_count[index]})`);
      });

      data.addRows(data_rows);

      let table_wrapper = document.getElementById('reports-downloads-table');
      let table_wrapper_height = table_wrapper.offsetHeight - 1;
      let table_wrapper_width = table_wrapper.offsetWidth - 1;
      let table = new window.googleCharts.visualization.Table(table_wrapper);
      table.draw(data, {showRowNumber: false, width: table_wrapper_width, height: table_wrapper_height, frozenColumns: 1,});
    },
    loadDownloadsList: _.debounce(function () {
      axios.post('/reports/getDownloadsData', {
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        content_upload_type_filter: this.content_upload_type_filter,
        selected_company_types: this.selected_company_types,
        selected_system_types: this.selected_system_types,
        selected_company_system_types: this.selected_company_system_types,
      }).then((response) => {
        this.downloads_list = response.data;
        this.filtering = false;
        window.googleCharts.charts.setOnLoadCallback(this.drawTable);
      });
    }, 250),
    loadContentUploadTypesList: _.debounce(function () {
      axios.post('/reports/getContentUploadTypes', {
        content_upload_type_filter: this.content_upload_type_filter,
      }).then((response) => {
        this.content_upload_types = response.data;

        if (this.data_mode === 'pie') {
          this.loadDownloadsPieData();
        }

        if (this.data_mode === 'table') {
          this.loadDownloadsList();
        }

      });
    }, 250),
    loadDownloadsPieData: _.debounce(function () {
      axios.post('/reports/getDownloadsPieData', {
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        content_upload_type_filter: this.content_upload_type_filter,
        selected_company_types: this.selected_company_types,
        selected_system_types: this.selected_system_types,
        selected_company_system_types: this.selected_company_system_types,
      }).then((response) => {
        this.downloads_pie_data = response.data;
        this.filtering = false;
        window.googleCharts.charts.setOnLoadCallback(this.drawPie);
      });
    }, 250),
    exportSpreadsheet() {
      this.exporting = true;
      axios({
        url: '/reports/export/downloads',
        method: 'POST',
        responseType: 'blob',
        data: {
          date_filter_start: this.date_filter_start,
          date_filter_end: this.date_filter_end,
          content_upload_type_filter: this.content_upload_type_filter,
          selected_company_types: this.selected_company_types,
          selected_system_types: this.selected_system_types,
          selected_company_system_types: this.selected_company_system_types,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reports_downloads.xlsx');
        document.body.appendChild(link);
        link.click();
        this.exporting = false;
      });
    },
  },
  watch: {
    date_filter_start() {
      this.filtering = true;
      this.loadContentUploadTypesList();
    },
    date_filter_end() {
      this.filtering = true;
      this.loadContentUploadTypesList();
    },
    content_upload_type_filter() {
      this.filtering = true;
      this.loadContentUploadTypesList();
    },
    selected_company_types() {
      this.filtering = true;
      this.loadContentUploadTypesList();
    },
    selected_system_types() {
      this.filtering = true;
      this.loadContentUploadTypesList();
    },
    selected_company_system_types() {
      this.filtering = true;
      this.loadContentUploadTypesList();
    },
    data_mode() {
      this.filtering = true;
      this.loadContentUploadTypesList();
    },
  },
};
</script>
